/**
 * Experiment keys registered for A/B testing via GrowthBook.
 *
 * These are GrowthBook *tracking keys* (the ID shown on the Experiments tab),
 * used for hashing/bucketing and analytics. They are NOT necessarily the same
 * as the GrowthBook *Feature Key* that serves the value — see EXPERIMENT_FEATURE_KEY.
 * Tenant targeting is configured in GrowthBook, NOT in code.
 *
 * @see docs/guides/experiments.md - Full setup guide
 */
export enum AllowedExperimentKey {
  LISTING_HERO = 'dj-listing-hero-redesign',
  STICKY_HEADER_TABS = 'dj-listing-sticky-tab-bar-redesign',
  CONNECTION_REQUEST_FORM = 'dj-listing-connection-request-form-redesign',
  PROPERTY_DRAWER_AUTO_COLLAPSE = 'property-drawer-auto-collapse',
  ZOOPRAISAL_MORTGAGE_CTA = 'zoopraisal-mortgage-cta',
  LOCAL_FOCUS_HOMEPAGE = 'local-focus-homepage',
  AREA_PAGE_V2_REDESIGN = 'dj-area-page-redesign'
}

/**
 * Maps each experiment's tracking key to the GrowthBook Feature Key that
 * actually serves its value. The two differ for experiments where the
 * feature was named independently of its tracking key on the GrowthBook
 * dashboard — copy the Feature Key from the Feature's page, not the
 * Experiment's tracking key, when registering a new entry here.
 */
export const EXPERIMENT_FEATURE_KEY: Record<AllowedExperimentKey, string> = {
  [AllowedExperimentKey.LISTING_HERO]: 'listing-hero-redesign',
  [AllowedExperimentKey.STICKY_HEADER_TABS]: 'listing-sticky-tab-bar',
  [AllowedExperimentKey.CONNECTION_REQUEST_FORM]: 'listing-connection-request-form',
  [AllowedExperimentKey.PROPERTY_DRAWER_AUTO_COLLAPSE]: 'property-drawer-auto-collapse',
  [AllowedExperimentKey.ZOOPRAISAL_MORTGAGE_CTA]: 'zoopraisal-mortgage-cta',
  [AllowedExperimentKey.LOCAL_FOCUS_HOMEPAGE]: 'homepage-local-focus',
  [AllowedExperimentKey.AREA_PAGE_V2_REDESIGN]: 'dj-area-page-redesign',
};
